module.exports = __webpack_public_path__ + "img/upload_receipt.dd905d2a.png";